import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../config';

export default class extends React.Component {

  state = {
    back: false
  };

  openFacebook() {

    Config.setGroup(this.props.match.params.group);
    window.open(Config.getFacebookReviewLink(), '_blank');
  }

  render() {
    return (
      <div className="content-inner-container facebook">
        <div className="facebook-inner">
          <div className="back" onClick={() => this.setState({ back: true })}>
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </div>
          <i className="fa fa-facebook" />
          <p>
            Facebook lets us stay connected with our customers, fans and friends - and lets you review businesses.
          </p>
          <button onClick={this.openFacebook.bind(this)} className="mobile">
            Click to review us on Facebook
          </button>
          <img className="desktop" src="/images/facebook images.png" />
          <p className="explainer">
            <strong>"Like"</strong> our page if you want to stay connected with us<br />
            Find the <strong>"Reviews"</strong> widget in the body of the page and rate us.<br />
            <strong>Log in</strong> or <strong>sign up</strong> if you haven't already to complete the process
          </p>
          <button onClick={this.openFacebook.bind(this)} className="desktop">
            Click to review us on Facebook
          </button>
          <p className="explainer note">
            Note: This website is not affiliated with or endorsed by Facebook.
          </p>
        </div>
        {
          this.state.back ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you`} />
          ) : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/states/facebook/index.js